module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26320/sass/messagesWidgetShell.sass"